<template>
    <v-dialog
        v-model="isOpen"
        max-width="1000"
        @keydown.esc.prevent="$emit('closeModal')"
        persistent
        @click:outside="$emit('closeModal')"
    >
        <v-card class="pa-0" v-if="fileValue && fileValue.link">
            <v-toolbar color="grey lighten-4 px-3" flat>
                <v-toolbar-title>{{ fileValue.name }}</v-toolbar-title>
                <v-spacer></v-spacer>
                <v-btn color="primary">
                    <a :href="fileValue.downloadLink"
                       download
                       style="color: white; text-decoration: none;"
                    >Download</a>
                </v-btn>
                <v-btn icon @click="$emit('closeModal')">
                    <v-icon>$close</v-icon>
                </v-btn>
            </v-toolbar>
            <div v-if="hasPreview">
                <div v-if="isValidImage">
                    <v-carousel class="white"
                                v-model="carouselIndexValue"
                                hide-delimiters
                    >
                        <v-carousel-item
                            v-for="(item, index) in uploadedImages"
                            :key="index"
                            :src="item.link"

                            reverse-transition="fade-transition"
                            transition="fade-transition"
                        >
                            <v-btn absolute right top icon dense @click="$emit('deleteImage', item)">
                                <v-icon>mdi-delete</v-icon>
                            </v-btn>
                            <a :href="item.downloadLink" download class="download-icon-btn">
                                <v-icon>$download</v-icon>
                            </a>
                        </v-carousel-item>
                    </v-carousel>
                    <div class="py-5">
                        <v-bottom-navigation class="elevation-0">
                            <v-card :key="item.id" v-for="(item, index) in uploadedImages" @click="$emit('setActiveImg', index)"
                                    class="mr-4 align-stretch d-flex" :class="index !== carouselIndexValue ? 'opacity-4' : ''">
                                <v-img max-width="100px" :src="item.link"></v-img>
                            </v-card>
                        </v-bottom-navigation>
                    </div>
                </div>
                <div v-if="isValidVideo">
                    <video-player :src="fileValue.link" :extension="fileValue.extension"></video-player>
                </div>
                <div v-else>
                    <iframe v-if="isPdf" :src="fileValue.link" width="100%" height="800px"></iframe>
                    <VueDocPreview v-if="isOfficeDocument" :value="fileValue.link" type="office" />
                </div>
            </div>
            <div v-else class="no-preview-text">
                <v-icon size="50" style="width: 50px; fill: #ccc;">$file</v-icon>
                <h3>Preview not available</h3>
            </div>
        </v-card>
    </v-dialog>
</template>

<script>
  import VueDocPreview from 'vue-doc-preview'
  import VideoPlayer from './VideoPlayer'
  export default {
    components: {
      VueDocPreview,
      VideoPlayer
    },
    props: ['fileValue', 'isOpen', 'uploadedImages', 'carouselIndex'],
    data: () => ({
        carouselIndexValue: null
    }),
    computed: {
      isValidImage () {
        return this.fileValue.extension === '.jpeg' || this.fileValue.extension === '.jpg' || this.fileValue.extension === '.png'
      },
      isPdf () {
        return this.fileValue.extension === '.pdf'
      },
      isOfficeDocument () {
        const validExtensions = ['.doc', '.xls', '.docx', '.xlsx', '.pptx']
        return validExtensions.includes(this.fileValue.extension)
      },
      hasPreview () {
        const validExtensions = ['.mov', '.mp4', '.jpeg', '.jpg', '.png', '.pdf', '.doc', '.xls', '.docx', '.xlsx', '.md', '.pptx']
        return validExtensions.includes(this.fileValue.extension)
      },
      isValidVideo () {
        return this.fileValue.extension === '.mp4' || this.fileValue.extension === '.mov'
      }
    },
    mounted () {
      this.carouselIndexValue = this.carouselIndex
    }
  }
</script>

<style>
    .download-icon-btn {
        position: absolute;
        right: 15px;
        top: 15px;
        background: white;
    }
    .no-preview-text {
        color: #ccc;
        text-align: center;
        padding: 200px 0;
    }
    .v-image__image--cover {
        background-size: contain;
    }
</style>
